import ReadleeProfile from "../../services/firebase/ReadleeProfile";
import { connect } from "react-redux";
import { RootState } from "../../state/configureStore";
import Loading from "./Loading";
import { Redirect, Route } from "react-router-dom";

interface ScreenProps {
  profile: ReadleeProfile | undefined;
  isConnectingUser: boolean;
}

function AppLoadingScreen(props: ScreenProps) {
  // Ensure the user is logged in
  if (!props.isConnectingUser && !props.profile) {
    return <Route component={() => <Redirect to={{ pathname: "/Login" }} />} render={undefined} />;
  }

  return <Loading />;
}

const mapStateToProps = (state: RootState): ScreenProps => {
  return {
    profile: state.currentUserState.currentUser,
    isConnectingUser: state.currentUserState.isConnectingUser,
  };
};

export default connect(mapStateToProps)(AppLoadingScreen);
